import { createSlice } from '@reduxjs/toolkit';

const videoGallerySlice = createSlice({
  name: 'videoGallery',
  initialState: { videos: [], loaded: false },
  reducers: {
    setVideos: (state, action) => { state.videos = action.payload; state.loaded = true; },
  },
});

export const { setVideos } = videoGallerySlice.actions;
export default videoGallerySlice;
